export const UNSUBSCRIBE_SUCCESS = 'UNSUBSCRIBE_SUCCESS';
export const UNSUBSCRIBE_FAILED = 'UNSUBSCRIBE_FAILED';

const initialStore = {
  error: false,
};

export default function unsubscribe(store = initialStore, action) {
  switch (action.type) {
    case UNSUBSCRIBE_SUCCESS: {
      return {
        error: false,
      };
    }

    case UNSUBSCRIBE_FAILED: {
      return {
        error: true,
      };
    }

    default:
      return store;
  }
}
